module.exports = __webpack_public_path__ + "static/img/auto-equipment.caa283e6.png";